import * as ActionTypes from "../action-types";

const remark_defaultState = [];

export const remark = (state = remark_defaultState, action) => {
  let newState = JSON.parse(JSON.stringify(state));

  if (!action) return newState;

  switch (action.type) {
    case ActionTypes.GET_REMARK_THRU_REFID: {
      const remarks = action.remark;

      newState = remarks;

      return newState;
    }
    case ActionTypes.CREATE_REMARK: {
      const remark = action.remark;
      const { remid } = remark;

      if (!newState.some((n) => n.remid === remid)) {
        newState.push(remark);
      }

      return newState;
    }
    case ActionTypes.UPDATE_REMARK: {
      const remark = action.remark;
      const { remid } = remark;

      newState = newState.map((n) => {
        if (n.remid === remid) {
          return remark;
        }
        return n;  
      });

      return newState;
    }
    case ActionTypes.DELETE_REMARK: {
      const remid = action.remid

      newState = newState.filter((n) => n.remid !== remid);

      return newState;
    }
    case ActionTypes.CLOSE_REMARK: {
      newState = []
      return newState;
    }
    default: {
      return state;
    }
  }
};
